module.exports = __webpack_public_path__ + "img/invoiceWrite.a6e817d6.png";